import type { Projectbetrokkene } from '@models/Projectbetrokkene'

import { apiClient } from '../../gateways/api'

export { updateProjectbetrokkeneDisciplines }

const updateProjectbetrokkeneDisciplines = async ({
  id,
  disciplines,
}: {
  id: string
  disciplines: NonNullable<Projectbetrokkene['disciplines']>
}): Promise<Projectbetrokkene> => {
  const { data } = await apiClient({
    url: `/rest/projectbetrokkene/${id}`,
    method: 'PATCH',
    data: { disciplines },
  })

  return data
}
